import { DefaultContainerProps } from 'app/infrastructure/redux';
import { safeNumericString, safeParam } from 'app/infrastructure/data/sanitize';
import { getBreadcrumbs } from 'app/area/shared/codetable/breadcrumbs';
import { CodetableAdministrationState, CodetableMetadata } from './types-store';

export const selectors = {

  breadcrumbs: (_: CodetableAdministrationState, props: DefaultContainerProps) => getBreadcrumbs(props.params),
  codeId: (_: CodetableAdministrationState, props: DefaultContainerProps) => safeNumericString(props.params.codeId),
  parentId: (_: CodetableAdministrationState, props: DefaultContainerProps) => safeNumericString(props.router.location.query ?
    props.router.location.query.parentId as string : undefined),
  section: (_: CodetableAdministrationState, props: DefaultContainerProps) => safeParam(props.params.section),
  categoryId: (_: CodetableAdministrationState, props: DefaultContainerProps) =>
    safeNumericString(props.router.location?.query?.categoryId as string),
  shouldPrompt: ({ list }: CodetableAdministrationState, _: DefaultContainerProps) =>
    list.modifiedItems?.length ?? 0 > 0
};

export const getCodetableMetadata = (metadata: CodetableMetadata, codetableId: number): CodetableMetadata =>
  !!metadata && !!metadata.codetable && metadata.codetable.id === codetableId ? metadata : undefined;
